module.exports = "images/teamed_image_09.png";